module.exports = __webpack_public_path__ + "static/perpetual-swaps-paper-4b66b3a35c0f8135a2b0229883a938f0.png";